export default "__VITE_ASSET__DbA1QdGS__"